import React, { useContext, useState } from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import { DataGrid } from '@mui/x-data-grid';
import { useLocation } from 'react-router-dom';

import PageHeader from '../components/pageHeader';
import DadosUsuario from '../utils/context';
import { fetchFlask } from '../utils/fetchFlask';
import { Alerta } from './alerta';
import SubmitButton from './submitButton';

const ComercialCRM = () => {
    const location = useLocation();
    const partner = location.pathname.includes('Consultor') || window.location.pathname.includes('consultor');
    const [cliente, setCliente] = useState('');
    const [desconto, setDesconto] = useState(20);
    const [unidade, setUnidade] = useState('');
    const [endereco, setEndereco] = useState('');
    const [consumo, setConsumo] = useState('');
    const [valor, setValor] = useState('');
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const [DDD, setDDD] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');

    const [rows, setRows] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);

    const [openAlerta, setOpenAlerta] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);

    const emailPortal = useContext(DadosUsuario).email;

    const columns = [
        {
            field: 'uniCol',
            headerName: 'Unidade',
            width: 150,
            editable: true
        },
        {
            field: 'enderecoCol',
            headerName: 'Endereço',
            width: 150,
            editable: true
        },
        {
            field: 'consumoCol',
            headerName: 'Consumo',
            type: 'number',
            width: 110,
            editable: true
        },
        {
            field: 'valorCol',
            headerName: '(R$) Valor Fatura',
            type: 'number',
            width: 150,
            editable: true
        },
        {
            field: ' ',
            renderCell: (params) => (
                <IconButton edge="end" onClick={() => deleteCC(params.row.id)}>
                    <DeleteIcon />
                </IconButton>
            )
        }
    ];

    const addUnidades = () => {
        if (!unidade || !endereco || !consumo || !valor) {
            alert('Preencha todos os campos para adicionar uma unidade!');
            return;
        }

        setRows([...rows, { id: rows.length + 1, uniCol: unidade, enderecoCol: endereco, consumoCol: consumo, valorCol: valor }]);
        setUnidade('');
        setEndereco('');
        setConsumo('');
        setValor('');
    };

    const deleteCC = (id) => {
        setRows((prevRows) => prevRows.filter((row) => row.id !== id));
    };

    const handleRowSelection = (newSelection) => {
        setSelectedRows(newSelection);
    };

    const processRowUpdate = (newRow) => {
        setRows((prevRows) =>
            prevRows.map((row) => (row.id === newRow.id ? newRow : row))
        );
        return newRow;
    };

    async function submitProposta(e) {
        e.preventDefault();
        setIsSubmit(true);

        if (rows.length === 0) {
            alert('Por favor insira pelo menos uma unidade!');
            return;
        }

        const dictUnidades = rows.map(row => ({
            unidade: row.uniCol,
            endereco: row.enderecoCol,
            consumo: row.consumoCol,
            valor: row.valorCol
        }));

        const body = JSON.stringify({
            cliente,
            desconto,
            telefone: DDD + phoneNumber,
            unidades: dictUnidades,
            email: emailPortal,
            partner
        });

        const response = await fetchFlask('criarProposta', body);
        if (response.status !== 'error') {
            const link = document.createElement('a');
            link.href = response.url;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        setMessage(response.message);
        setStatus(response.status);
        setOpenAlerta(true);
        setIsSubmit(false);
    }

    return (
        <Box>
            <Alerta
                texto={message}
                status={status}
                open={openAlerta}
                handleClose={() => setOpenAlerta(false)}
            />

            <PageHeader>Criar Proposta</PageHeader>

            <Grid container spacing={2}>
                <Grid item id='proposta' xs={12}>
                    <form method='POST' onSubmit={submitProposta}>
                        <Grid container spacing={2} sx={{ alignItems: 'center', justifyContent: 'center' }}>
                            <Grid xs={12}>
                                <Grid container direction="column" alignItems="center">
                                    <Grid padding={1}>
                                        <FormControl>
                                            <TextField
                                                required
                                                label='Cliente'
                                                value={cliente}
                                                onChange={(e) => setCliente(e.target.value)}
                                                fullWidth
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid padding={1}>
                                        <FormControl>
                                            <TextField
                                                required
                                                label='Desconto (%)'
                                                type='number'
                                                inputProps={{ min: 5, max: 30 }}
                                                value={desconto}
                                                onChange={(e) => setDesconto(e.target.value)}
                                                sx={{ width: '200px' }}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid sx={{ maxWidth: '120px' }} padding={1}>
                                        <FormControl>
                                            <TextField
                                                id='ddd'
                                                required
                                                label='DDD'
                                                value={DDD}
                                                onChange={(e) => setDDD(e.target.value)}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid padding={1}>
                                        <FormControl>
                                            <TextField
                                                id='phone'
                                                required
                                                label='Telefone'
                                                value={phoneNumber}
                                                onChange={(e) => setPhoneNumber(e.target.value)}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Box sx={{ height: 250 }}>
                            <DataGrid
                                rows={rows}
                                columns={columns}
                                processRowUpdate={processRowUpdate}
                                onSelectionModelChange={handleRowSelection}
                                localeText={{ noRowsLabel: 'Sem Unidades' }}
                                hideFooter
                            />
                        </Box>
                        {selectedRows.length > 0 && (
                            <Tooltip title="Delete">
                                <IconButton onClick={() => deleteCC(selectedRows)}>
                                    <DeleteIcon />
                                </IconButton>
                            </Tooltip>
                        )}

                        <Grid container spacing={2} sx={{ padding: 2, alignItems: 'center', justifyContent: 'center' }}>
                            <Grid>
                                <Grid padding={1}>
                                    <FormControl fullWidth>
                                        <TextField
                                            label='Unidade'
                                            value={unidade}
                                            onChange={(e) => setUnidade(e.target.value)}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid padding={1}>
                                    <FormControl fullWidth>
                                        <TextField
                                            label='Endereço'
                                            value={endereco}
                                            onChange={(e) => setEndereco(e.target.value)}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid padding={1}>
                                    <FormControl fullWidth>
                                        <TextField
                                            label='Consumo kWh'
                                            value={consumo}
                                            onChange={(e) => setConsumo(e.target.value)}
                                            type='number'
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid padding={1}>
                                    <FormControl fullWidth>
                                        <TextField
                                            label='(R$) Valor Fatura'
                                            value={valor}
                                            onChange={(e) => setValor(e.target.value)}
                                            type='number'
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Button variant='contained' onClick={addUnidades}>Adicionar Unidade</Button>
                            </Grid>
                        </Grid>

                        <FormControl sx={{ marginTop: '20px', marginBottom: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <SubmitButton isSubmit={isSubmit} >Criar Proposta</SubmitButton>
                        </FormControl>
                    </form>
                </Grid>

            </Grid>
        </Box>
    );
};

export default ComercialCRM;
